import Axios from "axios";

export default {
    /**
     *
     * @param {String} uid
     * @param {Number} productTypeId
     * @returns {Promise}
     */
    addItem: function (uid, productTypeId) {
        var data = new FormData();
        data.set("uid", uid);
        data.set("productTypeId", productTypeId);
        return Axios.post(URLSource.ajaxGetProductRow, data);
    },
    /**
     *
     * @param {Number} uid
     * @param {Number} itemUid
     * @returns {Promise}
     */
    removeItem: function (uid, itemUid) {
        var data = new FormData();
        data.set("uid", uid);
        data.set("rowUid", itemUid);
        return Axios.post(URLSource.ajaxRemoveProductRow, data);
    },
    prefillItems: function (uid, productTypeId) {
        var data = new FormData();
        data.set("uid", uid);
        data.set("productTypeId", productTypeId);
        return Axios.post(URLSource.ajaxPrefillProducts, data);
    },
    removeItemsByType: function (uid, productTypeId) {
        var data = new FormData();
        data.set("uid", uid);
        data.set("productTypeId", productTypeId);
        return Axios.post(URLSource.ajaxRemoveProductsByType, data);
    },
    addItemToBasket(uid, itemUid) {
        var data = new FormData();
        data.set("uid", uid);
        data.set("itemUid", itemUid);
        return Axios.post(URLSource.ajaxAddConfiguratorItemToBasket, data);
    },
    /**
     *
     * @param {String} uid
     * @param {int} productSetId
     * @returns {Promise}
     */
    setProductSet: function (uid, productSetId) {
        var data = new FormData();
        data.set("uid", uid);
        data.set("productSetId", productSetId);
        return Axios.post(URLSource.ajaxSetProductSet, data);
    },
    changeParameter: function (uid, rowUid, values) {
        var data = new FormData();
        data.set("uid", uid);
        data.set("rowUid", rowUid);
        data.set("jsonValues", JSON.stringify(values));
        return Axios.post(URLSource.ajaxChangeTPValue, data);
    },
    changeItemQuantity: function (uid, rowUid, quantity) {
        var data = new FormData();
        data.set("uid", uid);
        data.set("rowUid", rowUid);
        data.set("quantity", quantity);
        return Axios.post(URLSource.ajaxChangeProductRowQuantity, data);
    },
    updateConfiguratorData: function(uid) {
        var data = new FormData();
        data.set("uid", uid);
        return Axios.post(URLSource.ajaxUpdateConfiguratorData, data)
    },
    removeConfiguratorItems: function (uid) {
        var data = new FormData();
        data.set("uid", uid);
        return Axios.post(URLSource.ajaxRemoveConfiguratorItems, data);
    },
    addConfiguratorToBasket: function (uid, sets) {
        var data = new FormData();
        data.set("uid", uid);
        data.set("setsJson", JSON.stringify(sets));
        return Axios.post(URLSource.ajaxAddConfiguratorToBasket, data);
    },
    changePackQuantity: function (uid, collectionId, quantity) {
        var data = new FormData();
        data.set("uid", uid);
        data.set("collectionId", collectionId);
        data.set("quantity", quantity);
        return Axios.post(URLSource.ajaxChangePackQuantity, data);
    },
    changeCustomDimensions: function (uid, rowUid, values) {
        var data = new FormData();
        data.set("uid", uid);
        data.set("rowUid", rowUid);
        data.set("jsonValues", JSON.stringify(values));
        return Axios.post(URLSource.ajaxChangeCustomDimensions, data);
    },
    changeAutomaticFilling: function (uid, productTypeId, value) {
        var data = new FormData();
        data.set("uid", uid);
        data.set("productTypeId", productTypeId);
        data.set("value", value ? 1 : 0);
        return Axios.post(URLSource.ajaxChangeAutomaticFilling, data);
    }
};
